export default __webpack_public_path__ + "static/media/verified-icon.a0a789ad.svg";